import { render, staticRenderFns } from "./PaymentMethodsTab.vue?vue&type=template&id=33a7c10a&"
import script from "./PaymentMethodsTab.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports